module.exports = __webpack_public_path__ + "static/media/image-card-6.4b97677f.png";